import React from "react";
import heroBg from "../../../assets/images/hero.jpg";
import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContentFieldValue } from "../../../helpers/hooks/useContentFieldValue";

export const HeroWithSearch = (props) => {
    const image = useContentFieldValue("Image", props.contentFields);
    const title = useContentFieldValue("Title", props.contentFields);

    return (
        <section
            className="component hero hero__search"
            style={{ backgroundImage: `${heroBg ? `url(${heroBg})` : "none"}` }}
        >
            <section className="hero--inner">
                <h1>{title}</h1>
                <form
                    className="hero--form"
                    action="/ui/lms-learner-search/search"
                >
                    <input type="hidden" name="pageNumber" value="1" />
                    <input
                        type="text"
                        placeholder="Sök här..."
                        required
                        name="query"
                    />
                    <button>
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </form>
            </section>
            {image && (
                <img
                    src={image.mediaUrl}
                    alt={title}
                    style={{ maxHeight: "200px" }}
                />
            )}
        </section>
    );
};



// WEBPACK FOOTER //
// ./src/frontend/components/Fields/Hero/HeroWithSearch.js